import { SourceType } from 'module/api/filter/types';
import { useCompanyFieldsAsFilterableField } from 'helpers/fields/company-fields/fields';
import { AccountDetailsSectionComponentProps } from './types';
import { accountBlockResponseToLookup } from '../../shared/response-renderer-utils';
import { SharedDetailBlockGeneratedSection } from '../shared-detail-blocks/generated-section';

export const AccountDetailsGeneratedSection = ({
  node,
}: AccountDetailsSectionComponentProps) => {
  const { fields: companyFields, loading: isLoading } =
    useCompanyFieldsAsFilterableField();

  return (
    <SharedDetailBlockGeneratedSection
      node={node}
      sourceType={SourceType.Company}
      useFieldsHook={() => ({ fields: companyFields, loading: isLoading })}
      defaultTitleKey="rich_text_editor_sections_account_details"
      titlePlaceholderKey="rich_text_editor_sections_account_details_title_placeholder"
      fieldLabelKey="grouped_filter.company"
      responseToLookupFunction={accountBlockResponseToLookup}
    />
  );
};
